<template>
	<div
	:class="[
		`theme-${theme}`,
		'porlet-content', 
		'porlet-light', 
		{'porlet-transparent': porletTransparent},
		{'shadow': showShadow}, 
		{'divider': divider}, 
		{'collapsed': collapse}, 
		{'limit-height': height}, 
		{'marginBottom': marginBottom}, 
		{'no-visible': hiddenPorlet}
	]"
	:style="{'height': height ? height : '', 'margin': showMargin}">

		<header v-if="porlet && porlet.titulo && showHeader">
			<h3>{{ porlet.titulo }}</h3>

			<div>
				<el-button v-if="porlet.tipo == 'datatable'" class="reload-porlet" size="mini" @click="reload = true" :disabled="reload">
					<i class="el-icon-refresh-right"></i>
				</el-button>

				<el-button class="reload-porlet" size="mini" @click="collapse = !collapse">
					<i :class="[collapse ? 'el-icon-plus' : 'el-icon-minus']"></i>
				</el-button>
			</div>
		</header>
		
		<div v-show="!collapse" class="porlet-content-component">

			<component
				v-if="porlet.tipo == 'porlet'"
				:is="asyncComponent"
				:ref="`formulario_${id}`"
				:id="id"
				:ficha="ficha"
				:entidad="entidad"
				:objects="campos"
				:divider="divider"
				:focus="focus"
				:autosave="autosave"
				:inputList="inputList"
				:porlet="porlet"
				@input="input"
				@saved="(val) => $emit('saved',val)"
				@setCurrentAction="(val) => $emit('setCurrentAction',val)"
				@setActionId="(val) => $emit('setActionId',val)"
				@openWindow="val => $emit('openWindow',val)"
				@created="addRef()"
				@refsInputs="(val) => $emit('refsInputs', val)"/>
			
			<component
				v-if="porlet.tipo == 'porlethorizontal'"
				:is="asyncComponent"
				:id="id"
				:ficha="ficha"
				:entidad="entidad"
				:objects="campos"
				:divider="divider"
				:focus="focus"
				:autosave="autosave"
				:inputList="inputList"
				:porlet="porlet"
				@input="input"
				@saved="(val) => $emit('saved',val)"
				@setCurrentAction="(val) => $emit('setCurrentAction',val)"
				@setActionId="(val) => $emit('setActionId',val)"
				@created="addRef()"/>
			
			<component
				v-if="porlet.tipo == 'datatable'"
				:is="asyncComponent"
				tipo="relacion"
				:ref="id ? `datatable_${porlet.entidadRelacionada}_${id}` : `datatable_${porlet.entidadRelacionada}`"
				:id="id"
				:ficha="ficha"
				:entidad="entidad"
				:reload="reload"
				:entidadRelacionada="porlet.entidadRelacionada"
				:rowClickEnabled="porlet.attr.rowClickEnabled"
				:rowDblClickEnabled="porlet.attr.rowDblClickEnabled"
				:porlet="porlet"
				:activetab="activetab"
				:belongsTab="belongsTab"
				:autoReload="porlet.attr.autoreload"
				v-on="porlet.events"
				@openWindow="val => $emit('openWindow',val)"
				@close="(val) => $emit('closeTableClick',val)"
				@reloadEnd="reloadEnd()"
				@input="input"
				@saved="(val) => $emit('saved',val)"
				@setCurrentAction="(val) => $emit('setCurrentAction',val)"
				@setActionId="(val) => $emit('setActionId',val)"
				@created="addRef()"/>
			
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'Grafica'"
				:porlet="porlet"
				:ref="`grafica_${porlet.id}_${id}`"
				v-bind="porlet.props"
				v-on="porlet.events"
				:entidadRelacionada="porlet.entidadRelacionada"
				@created="addRef()"/>

			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'Documentos'"
				:ref="`documentos_${id}`"
				@openWindow="val => $emit('openWindow',val)"
				v-bind="porlet.props"
				v-on="porlet.events"
				:visible="true"
				@created="addRef()"/>
			
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'Informes'"
				:ref="`informes_${id}`"
				v-bind="porlet.props"
				v-on="porlet.events"
				:ficha="ficha" 
				:visible="true"
				@clickAction="val => $emit('clickActionInforme',val)"
				@created="addRef()"/>
			
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'Chat'"
				:user="user"
				wsUrl="ws://192.168.222.242:3000"
				:moment="moment"
				:visible="true"/>
			
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'Actividad'"
				:ref="`actividad_${id}`"
				v-bind="porlet.props"
				v-on="porlet.events"
				:visible="activetab == 'Actividad'"
				@created="addRef()"/>
			
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'Comentarios'"
				:ref="`comentarios_${id}`"
				v-bind="porlet.props"
				v-on="porlet.events"
				:visible="true"
				@created="addRef()"/>

			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'Graficas'"
				v-bind="porlet.props"
				v-on="porlet.events"
				@created="addRef()"/>
			
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'HookCustom'"
				:ref="`hook_${entidad}_${id}`"
				:id="id"
				:ficha="ficha"
				:entidad="entidad"
				:componente="porlet.componente"
				:porlet="porlet"
				v-bind="porlet.props"
				v-on="porlet.events"
				@reloadDataTable="reloadDataTable"/>
			
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'HookCustomRemote'"
				:id="id"
				:ficha="ficha"
				:entidad="entidad"
				:entidadRelacionada="porlet.entidadRelacionada"
				:componente="porlet.componente"
				:porlet="porlet"
				v-bind="porlet.props"
				v-on="porlet.events"/>
			
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'Iframe'"
				:porlet="porlet"
				:entidad="entidad"
				:id="id"
				v-bind="porlet.props"
				v-on="porlet.events"/>
			
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'MenuHeader'"
				v-bind="porlet.props"
				v-on="porlet.events" 
				:id="id"
				:ficha="ficha" 
				@openWindow="val => $emit('openWindow',val)"/>
			
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'MenuSearch'"
				v-bind="porlet.props"
				v-on="porlet.events"
				:id="id"
				:ficha="ficha"
				@openSearch="$emit('openSearch')"/>
			
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'MenuActions'" 
				v-bind="porlet.props"
				v-on="porlet.events"
				:id="id"
				:ficha="ficha"
				:porlet="porlet"
				@clickAction="(val) => $emit('clickAction',val)"/>

			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'Cabecera'"
				v-bind="porlet.props"
				v-on="porlet.events"
				:id="id"
				:ficha="ficha"
				:entidad="entidad"
				:porlet="porlet">
								
				<Porlet
					v-for="(elemento, e) in porlet.slots"
					:slot="elemento.tipo"
					:key="e"
					:ficha="ficha"
					:id="id"
					:entidad="entidad"
					:porlet="elemento"
					:showHeader="elemento.attr && elemento.attr.hasOwnProperty('showHeader') ? elemento.attr.showHeader : true"
					:showFooter="elemento.attr && elemento.attr.hasOwnProperty('showFooter') ? elemento.attr.showFooter : true"
					:showShadow="elemento.attr && elemento.attr.hasOwnProperty('showShadow') ? elemento.attr.showShadow : true"
					:visible="elemento.attr && elemento.attr.hasOwnProperty('visible') ? elemento.attr.visible : true"
					:marginBottom="elemento.attr && elemento.attr.hasOwnProperty('marginBottom') ? elemento.attr.marginBottom : true"
					:height="elemento.attr.height"
					@setCurrentAction="(val) => $emit('setCurrentAction',val)"
					@saved="(val) => $emit('saved',val)"
					@setActionId="(val) => $emit('setActionId',val)"
					@reloadDataTable="reloadDataTable"
					@openWindow="val => $emit('openWindow',val)"
					@dblClickSearch="val => $emit('dblClickSearch',val)" />

			</component>

			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'Calendar'"
				v-bind="porlet.props"
				v-on="porlet.events"
				:id="id"
				:ficha="ficha"
				:entidad="entidad"
				@openWindow="val => $emit('openWindow',val)"/>
			
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'InfoBox'"
				v-bind="porlet.props"/>
			
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'Label'"
				v-bind="porlet.props"/>
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'Link'"
				v-bind="porlet.props"/>
			
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'Buscador'"
				v-bind="porlet.props"
				:ref="(`buscador`)"
				:ficha="ficha"
				:entidad="entidad"
				:porlet="porlet"
				@openWindow="val => $emit('openWindow',val)"
				@dblClickSearch="val => $emit('dblClickSearch', val)"/>

			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'Cuadromando'"
				v-bind="porlet.props"
				:ref="(`cuadromando`)"
				:ficha="ficha"
				:entidad="entidad"
				:porlet="porlet"
				/>
			
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'OpenDrawerRight'"
				v-bind="porlet.props"
				:id="id"
				:ficha="ficha"/>

			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'OpenDrawerLeft'"
				v-bind="porlet.props"
				:id="id"
				:ficha="ficha"/>
			
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'GestorDocumental'"
				v-bind="porlet.props"
				:id="id"
				:ficha="ficha"/>

			<component
				:is="asyncComponent"
				:ref="`visor`"
				v-if="porlet.tipo == 'VisorDocumental'"
				v-bind="porlet.props"
				:id="id"
				:ficha="ficha"
				@created="addRef()"/>

			<component
				:is="asyncComponent"
				:ref="`busquedasguardadas`"
				v-if="porlet.tipo == 'BusquedasGuardadas'"
				v-bind="porlet.props"
				:entidad="entidad"
				:id="id"
				:ficha="ficha"
				@created="addRef()"/>
			
			<component
				:is="asyncComponent"
				:ref="`ADM`"
				v-if="porlet.tipo == 'ADM'"
				v-bind="porlet.props"
				:entidad="entidad"
				:id="id"
				:ficha="ficha"/>

			<component
				:is="asyncComponent"
				:ref="`TASK`"
				v-if="porlet.tipo == 'TASK'"
				v-bind="porlet.props"
				:entidad="entidad"
				:id="id"
				:ficha="ficha"/>
			
			<component
				:is="asyncComponent"
				:ref="`NAV`"
				v-if="porlet.tipo == 'NAV'"
				v-bind="porlet.props"
				:entidad="entidad"
				:id="id"
				:ficha="ficha"/>
			
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'Columnas'"
				v-bind="porlet.props"
				:inputList="inputList"
				:objects="campos"
				:entidad="entidad"
				:id="id"
				:ficha="ficha"
				:porlet="porlet"
				@input="input"
				@saved="(val) => $emit('saved',val)"
				@refsInputs="(val) => $emit('refsInputs', val)"/>
			
			<component
				:ref="id ? `calendario_${id}` : `calendario`"
				:is="asyncComponent"
				v-if="porlet.tipo == 'Calendario'"
				v-bind="porlet.props"
				:entidad="entidad"
				:id="id"
				:ficha="ficha"
				:porlet="porlet"
				@created="addRef()"
				@saved="(val) => $emit('saved',val)"/>
			
			<component
				:is="asyncComponent"
				ref="VisorPDF"
				v-if="porlet.tipo == 'VisorPDF'"
				v-bind="porlet.props"
				:entidad="entidad"
				:id="id"
				:ficha="ficha"
				:porlet="porlet"
				@created="addRef()"
				@afterActions="(val) => $emit('afterActions',val)"
				@saved="(val) => $emit('saved',val)"/>
			
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'VisorOCR'"
				v-bind="porlet.props"
				:entidad="entidad"
				:id="id"
				:ficha="ficha"
				:porlet="porlet"
				@saved="(val) => $emit('saved',val)"/>

			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'Listado'"
				v-bind="porlet.props"
				:entidad="entidad"
				:id="id"
				:ficha="ficha"
				:porlet="porlet"
				ref="Listado"
				@created="addRef()"
				@saved="(val) => $emit('saved',val)"/>
			
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'Form'"
				v-bind="porlet.props"
				:entidad="entidad"
				:id="id"
				:ficha="ficha"
				:porlet="porlet"
				@saved="(val) => $emit('saved',val)"
				@afterActions="(val) => $emit('afterActions',val)"/>
			
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'Dashboard'"
				v-bind="porlet.props"
				:entidad="entidad"
				:id="id"
				:ficha="ficha"
				:porlet="porlet"
				@openWindow="val => $emit('openWindow',val)"
				@saved="(val) => $emit('saved',val)"/>
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'DashboardDOOX'"
				v-bind="porlet.props"
				:entidad="entidad"
				:id="id"
				:ficha="ficha"
				:porlet="porlet"
				@openWindow="val => $emit('openWindow',val)"
				@saved="(val) => $emit('saved',val)"/>

			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'Compiled'"
				v-bind="porlet.props"
				:entidad="entidad"
				:id="id"
				:ficha="ficha"
				:porlet="porlet"
				@openWindow="val => $emit('openWindow',val)"
				@saved="(val) => $emit('saved',val)"/>

			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'GDS'"
				v-bind="porlet.props"
				:entidad="entidad"
				:id="id"
				:ficha="ficha"
				:porlet="porlet"
				@openWindow="val => $emit('openWindow',val)"
				@saved="(val) => $emit('saved',val)"/>

				<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'ControlTrabajo'"
				v-bind="porlet.props"
				:entidad="entidad"
				:id="id"
				:ficha="ficha"
				:porlet="porlet"
				@openWindow="val => $emit('openWindow',val)"
				@saved="(val) => $emit('saved',val)"/>

			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'MapaAlmacen'"
				v-bind="porlet.props"
				:entidad="entidad"
				:id="id"
				:ficha="ficha"
				:porlet="porlet"
				@openWindow="val => $emit('openWindow',val)"
				@saved="(val) => $emit('saved',val)"/>
			
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'Tree'"
				v-bind="porlet.props"
				:entidad="entidad"
				:id="id"
				:ficha="ficha"
				:porlet="porlet"
				@openWindow="val => $emit('openWindow',val)"
				@saved="(val) => $emit('saved',val)"/>
				
			<component
				:is="asyncComponent"
				v-if="porlet.tipo == 'Central'"
				v-bind="porlet.props"
				v-on="porlet.events"
				:id="id"
				:ficha="ficha"
				:entidad="entidad"
				:porlet="porlet">
								
				<Porlet
					v-for="(elemento, e) in porlet.slots"
					:slot="elemento.slot"
					:key="e"
					:ficha="ficha"
					:id="id"
					:entidad="entidad"
					:porlet="elemento"
					:showHeader="elemento.attr && elemento.attr.hasOwnProperty('showHeader') ? elemento.attr.showHeader : true"
					:showFooter="elemento.attr && elemento.attr.hasOwnProperty('showFooter') ? elemento.attr.showFooter : true"
					:showShadow="elemento.attr && elemento.attr.hasOwnProperty('showShadow') ? elemento.attr.showShadow : true"
					:visible="elemento.attr && elemento.attr.hasOwnProperty('visible') ? elemento.attr.visible : true"
					:marginBottom="elemento.attr && elemento.attr.hasOwnProperty('marginBottom') ? elemento.attr.marginBottom : true"
					:height="elemento.attr.height"
					@setCurrentAction="(val) => $emit('setCurrentAction',val)"
					@saved="(val) => $emit('saved',val)"
					@setActionId="(val) => $emit('setActionId',val)"
					@reloadDataTable="reloadDataTable"
					@openWindow="val => $emit('openWindow',val)"
					@dblClickSearch="val => $emit('dblClickSearch',val)" />

			</component>

		</div>

		<footer v-show="!collapse" v-if="showFooter">
			<template v-if="modal">
				<el-button @click="$emit('closed')" v-if="(modal && modal.attr && modal.attr.hasOwnProperty('buttonCancel') && modal.attr.buttonCancel) || !modal.attr.hasOwnProperty('buttonCancel')">
					Cancelar
				</el-button>
				<el-button
				v-for="(button,i) in modal.attr.buttons"
				:key="i"
				type="primary"
				size="medium"
				:loading="loadingAction"
				@click="actionFooter(button)">{{button.title}}</el-button>
			</template>
		</footer>

		<!-- EDITOR -->
        <Editor :params="porlet" :ficha="ficha" type="porlet"/>
		
	</div>
</template>

<script>
	import Editor from '@/components/Editor/Editor.vue'

	import { getRegistrosEntidad, getValoresLista, updatePropiedad, postActionData, setDefaultsHeaders} from '@/helpers/api'

	import { mapMutations, mapState } from 'vuex'

	import moment from 'moment'

	import {components} from '@/components/index.js'

	export default {
		name: 'Porlet',
		components: {
			Editor
		},
		props: {
			elemento: {
				type: Object,
				required: false
			},
			porlet: {
				type: Object,
				required: false
			},
			showMargin: {
				type: String,
				required: false,
				default: () => ''
			},
			showShadow: {
				type: Boolean,
				required: false,
				default: () => true
			},
			showHeader: {
				type: Boolean,
				required: false,
				default: () => true
			},
			showFooter: {
				type: Boolean,
				required: false,
				default: () => true
			},
			marginBottom: {
				type: Boolean,
				required: false,
				default: () => true
			},
			visible: {
				type: [Number, Boolean],
				required: false,
				default: true
			},
			height: {
				type: String,
				required: false
			},
			divider: {
				type: Boolean,
				required: false,
				default: () => true
			},
			focus: {
				type: Boolean,
				required: false,
				default: () => false
			},
			autosave: {
                type: Boolean,
                required: false,
                default: () => true
            },
			ficha: {
				type: Object,
				required: true
			},
			modal: Object,
			id: [Number,String],
			entidad: String,
			objects: {
				required: false,
				type: Array
			},
			forceReload: {
				type: Boolean,
				required: false,
				default: () => false
			},
			inputList: Array,
			activetab: {
				type: [Object,String]
			},
			belongsTab: {
				type: String
			},
			porletTransparent: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {
				theme: window.distributionconfig.theme,
				reload: false,
				loadingAction: false,
				collapse: false,
				moment,
				asyncComponent: null
			}
		},
		computed: {
			...mapState({
				user: state => state.user.data
			}),
			campos() {
				
				if (!['Columnas','porlet','porlethorizontal'].includes(this.porlet.tipo)) return []

				return this.objects && this.objects.length > 0 ? this.objects : Object.keys({...this.ficha.data, ...this.ficha.tables}).map(key => {
					const el = {...this.ficha.data,...this.ficha.tables}[key]
					el.key = key
					return (typeof el == 'object' && el.porlet === this.porlet.id) ? el : ''
				}, this)
				.filter(el => el !== '')
				.sort((a,b) => a.order - b.order)
				
			},
			hiddenPorlet() {
				let hidden = false
				if(!this.visible || (this.campos && this.campos.length && this.campos.every(c => c.state == ""))) {
					hidden = true
				}
				return hidden
			}
		},
		watch: {
			forceReload() {
				if (this.forceReload) {
					this.reload = true
				}
			}
		},
        mounted() {
			this.render()
        },
		methods: {
			
			async render() {

				let theme = window.distributionconfig.theme
				let comp = this.porlet.tipo
				
				let component = null
				let path = null

				if (components[theme] && components[theme][comp]) {
					
					path = components[theme][comp]
					component = import(`./${theme}/${path}`)

				} else {
					
					path = components['Default'][comp]
					component = import(`./${path}`)
				}

				this.asyncComponent = () => ({ component })
				
			},

			addRef() {
				
				let key = null
				switch (this.porlet.tipo) {
					case 'datatable':
						key = `datatable_${this.porlet.entidadRelacionada}`
						break;
					case 'Grafica':
						key = `grafica`
						break;
					case 'Actividad':
						key = `actividad`
						break;
					case 'Documentos':
						key = `documentos`
						break;
					case 'Comentarios':
						key = `comentarios`
						break;
					case 'Informes':
						key = `informes`
						break;
					case 'VisorPDF':
						key = 'VisorPDF'
						break;
					case 'Listado':
						key = 'Listado'
						break;
					case 'Calendario':
						key = 'calendario'
						break;
					case 'VisorDocumental':
						key = 'visor'
						break;
					case 'busquedasguardadas':
						key = 'busquedasguardadas'
						break;
				}
				
				if (key) {

					key = this.id ? `${key}_${this.id}` : key

					this.$addRef(key, this.$refs[key])
				}
			},
			reloadDataTable(data) {
				this.$referencias.find(d => d.entidadRelacionada == 'lineapedidocompra').reloadContent()
			},
			setAxiosHeaders() {
				/*axios.defaults.headers.common['Entidad'] = this.entidad
			
				if (this.id && !isNaN(parseInt(this.id))) {
					axios.defaults.headers.common['Id'] = this.id
				}*/

				setDefaultsHeaders(this.entidad, this.id)
			},

			async actionFooter(action) {
				
				this.setAxiosHeaders()

				// Validar campos
				if(Object.keys(this.modal.data).some(key => this.modal.data[key].obligatorio == 1 && this.modal.data[key].value == "")) {
					this.$notify.error({
						title: 'Error',
						message: 'Rellena los campos obligatorios'
					});

					// Poner en rojo campos obligatorios no rellenos
					Object.keys(this.modal.data).forEach(input => {
						if(this.modal.data[input].obligatorio == 1 && this.modal.data[input].value == "") {
							this.modal.data[input].class = this.modal.data[input].class ? `${this.modal.data[input].class} required` : 'required'
						}
					})

					return
				}
				
				this.loadingAction = true

				try {

					if (action.accion) {

						let resp = await postActionData(action.accion.replace('@@id@@', this.id), this.modal.data, action.metodo.toLowerCase() || 'post')

						this.$emit('afterActions', resp.data, action)

						if (resp.status === 200) this.$emit('closed')

					} else {

						this.$emit('closed')		

					}

				} catch(err) {
					console.log(err)
					this.$notify.error({
						title: 'Error',
						message: 'Ha ocurrido un error'
					});
				}

				this.loadingAction = false

			},

			input(data) {
				if(this.modal) {
					this.modal.data[data.input.key].value = data.newvalue
				}
			},
			reloadEnd() {
				this.reload = false
				this.$emit('reloadEnd')
			}
		}
	}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';
.porlet-content {
	background-color: transparent;
	border-radius: 4px;
	margin-bottom: 0px;
	//height: 100%;
	display: flex;
	flex-grow: 1;
	position: relative;
	flex-flow: column;
	height: inherit;
	&.marginBottom {
		margin-bottom: 15px;
	}
	&.shadow {
		box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
	}
	&.divider {
		footer {
			padding: 2px;
		}
	}
	&.collapsed {
		header {
			border-radius: 4px;
			border: 0px;
		}
	}
	&.limit-height {
		> div {
			overflow: auto!important;
		}
	}
	&.no-visible {
		display: none;
	}
	&.porlet-light {
		background-color: white;
		> header {
			background: $--color-header;
			color: white;
		}
		.formulario {
			background-color: white;
			border: 0px;
		}
	}
	&.porlet-transparent {
		background-color: transparent!important;
	}
	
	/* Header */
	> header {
		display: flex;
		flex-shrink: 0;
		justify-content: space-between;
		align-items: center;
		background: #fafafa;
		color: #303133b5;
		border-top-left-radius: 4px;
		border-top-right-radius: 4px;
		padding: 0.4rem 0.5rem 0.7rem 0.5rem;
		text-transform: uppercase;
		font-weight: 500;
		h3 {
			margin: 0;
			font-size: 0.85rem;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			height: 19px;
		}
		.reload-porlet {
			padding: 5px;
			font-size: 0.9rem;
			margin-left: 5px;
			background-color: #ff000000;
			border: 0px;
			color: #303133;
		}
	}
	&.theme-Metronic { 
		> header {
			background-color: white;
			padding: 1.5rem 1.5rem 0.7rem 1.5rem;
			h3 {
				color: #181C32;
				font-size: 1.275rem;
				font-weight: 600;
				text-transform: capitalize;
			}
		}
	}
	

	/* Footer */
	> footer {
		border-radius: 0px 0px 4px 4px;
		display: flex;
		justify-content: flex-end;
		padding: 8px 0px;
		//background-color: white;
	}
	.porlet-content-component {
		//height:100%;
		flex-grow: 1;
		display: flex;
		flex-flow: column;
	}
}
</style>
